import { graphql, useMutation } from "react-relay";
import { useWorkspaceSignalEditAddFileMutation } from "./__generated__/useWorkspaceSignalEditAddFileMutation.graphql";

export function useWorkspaceSignalEditAddFiles() {
  const [addFileMutation] = useMutation<useWorkspaceSignalEditAddFileMutation>(
    graphql`
      mutation useWorkspaceSignalEditAddFileMutation(
        $signalWorkspaceId: ID!
        $fileIds: [ID!]!
      ) {
        signalWorkspace(id: $signalWorkspaceId) {
          addFiles(fileIds: $fileIds) {
            id
            ...WorkspaceSignalEditMainEditedInfo_Signal
            descriptionFiles {
              id
              type
              url
              name
            }
          }
        }
      }
    `
  );

  return (signalWorkspaceId: string, fileIds: string[]) => {
    return addFileMutation({
      variables: {
        signalWorkspaceId,
        fileIds,
      },
    });
  };
}
